import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }) => ({
  select: {
    '& > .MuiSelect-root': {
      display: 'flex',
      gap: '8px',
      flexShrink: 0,
      paddingRight: 0,
      '& > button': {
        display: 'none',
      },
      '& > span': {
        paddingRight: 16,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    width: '100%',
    marginBottom: 20,
  },
  customGradientListItem: {
    width: '320px',
    display: 'flex',
    gap: 8,
    '& > span': {
      flexGrow: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& button': {
      visibility: 'hidden',
    },
    '&:hover button': {
      visibility: 'visible',
    },
    '&:hover button.disabled': {
      opacity: 0.3,
    },
  },
  listHeader: {
    pointerEvents: 'none',
    userSelect: 'none',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 400,
    color: palette.common.white,
  },
  subHeader: {
    pointerEvents: 'none',
    userSelect: 'none',
    fontSize: '10px',
    color: palette.primary.text7,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
  },
  addButton: {
    pointerEvents: 'all',
    '&:hover': {
      background: 'transparent',
    },
  },
}));
